import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const navLinks = [
  { label: "Início", href: "#inicio" },
  { label: "Quem Somos", href: "#quem-somos" },
  { label: "Soluções", href: "#solucoes" },
  { label: "Parceiros", href: "#parceiros" },
  { label: "Clientes", href: "#clientes" },
  { label: "Contato", href: "#contato" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const isHomePage = location.pathname === "/" || location.pathname === "";
  const useDarkStyle = !isHomePage || scrolled;

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        useDarkStyle
          ? "bg-white/95 backdrop-blur-md border-b border-[#62A9E0]/20"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-16">
        {/* Logo */}
        <a
          href={isHomePage ? "#inicio" : "/"}
          onClick={(e) => {
            if (isHomePage) {
              e.preventDefault();
              handleNav("#inicio");
            }
          }}
          className="flex items-center gap-1 cursor-pointer"
        >
          <span
            className={`text-2xl font-black tracking-tight ${
              useDarkStyle ? "text-[#000000]" : "text-white"
            }`}
          >
            SOLUS
          </span>
          <span className="text-2xl font-black tracking-tight solus-gradient-text">IT</span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={isHomePage ? link.href : `/${link.href}`}
              onClick={(e) => {
                if (isHomePage) {
                  e.preventDefault();
                  handleNav(link.href);
                }
              }}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                useDarkStyle
                  ? "text-[#000000] hover:text-[#62A9E0]"
                  : "text-white/90 hover:text-[#62A9E0]"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="https://suporte.solus-it.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            className="px-5 py-2 solus-btn-primary text-white text-sm font-semibold rounded-md cursor-pointer whitespace-nowrap"
          >
            Abrir um chamado
          </a>
        </div>

        {/* Mobile menu button */}
        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
            useDarkStyle ? "text-[#000000]" : "text-white"
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`ri-${menuOpen ? "close" : "menu"}-line text-2xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-[#62A9E0]/20 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={isHomePage ? link.href : `/${link.href}`}
              onClick={(e) => {
                if (isHomePage) {
                  e.preventDefault();
                  handleNav(link.href);
                }
              }}
              className="text-[#000000] text-sm font-medium hover:text-[#62A9E0] transition-colors cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://suporte.solus-it.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            className="px-5 py-2 solus-btn-primary text-white text-sm font-semibold rounded-md text-center cursor-pointer whitespace-nowrap"
          >
            Abrir um chamado
          </a>
        </div>
      )}
    </header>
  );
}
